import axios from 'axios';
import { translate } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import moment from 'moment';

export const ACTION_TYPES = {
  RESET: 'approve-management/RESET',
  APPROVE_USER: 'approve-management/APPROVE_USER',
  GET_USER_INFO: 'approve-management/GET_USER_INFO',
  GET_USER_LIST: 'approve-management/GET_USER_LIST',
  GET_ACCOUNT_LIST: 'approve-management/GET_ACCOUNT_LIST',
  GET_ACCOUNT_INFO: 'approve-management/GET_ACCOUNT_INFO',
  GET_USER_COMPARISON: 'approve-management/GET_USER_COMPARISON',
  EXPORT_EXCEL: 'approve-management/EXPORT_EXCEL',
  CHANGE_ACCOUNT_STATUS: 'approve-management/CHANGE_ACCOUNT_STATUS',
  DELETE_ACCOUNT: 'approve-management/DELETE_USER',
  DELETE_USER_APPROVE: 'approve-management/DELETE_USER_APPROVE',
  SAVE_USER_INFO: 'approve-management/USER_INFO',
  CANCEL_USER: 'approve-management/CANCEL_USER',
  LINK_ACCOUNT: 'approve-management/LINK_ACCOUNT'
};

const initialState = {
  loading: false,
  errorMessage: null,
  totalCount: 0,
  userInfo: {} as any,
  userList: [] as any[],
  accountList: [] as any[],
  accountData: {} as any,
  userComparison: [] as any[],
  responseApprove: {} as any,
  responseDelete: {} as any,
  responseChange: {} as any,
  resExportExcel: {} as any,
  userData: {} as any,
  resCancelUser: {} as any,
  resDeleteUserApprove: {} as any,
  resLinkAccount: {} as any
};

export type ApproveManagementState = Readonly<typeof initialState>;

export default (state: ApproveManagementState = initialState, action): ApproveManagementState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.APPROVE_USER):
    case REQUEST(ACTION_TYPES.GET_USER_INFO):
    case REQUEST(ACTION_TYPES.GET_USER_LIST):
    case REQUEST(ACTION_TYPES.GET_ACCOUNT_LIST):
    case REQUEST(ACTION_TYPES.GET_USER_COMPARISON):
    case REQUEST(ACTION_TYPES.LINK_ACCOUNT):
    case REQUEST(ACTION_TYPES.DELETE_ACCOUNT):
    case REQUEST(ACTION_TYPES.DELETE_USER_APPROVE):
    case REQUEST(ACTION_TYPES.CHANGE_ACCOUNT_STATUS):
    case REQUEST(ACTION_TYPES.GET_ACCOUNT_INFO):
    case REQUEST(ACTION_TYPES.CANCEL_USER):
      return {
        ...state,
        loading: true
      };
    case REQUEST(ACTION_TYPES.EXPORT_EXCEL):
      return {
        ...state
      };
    case FAILURE(ACTION_TYPES.APPROVE_USER):
    case FAILURE(ACTION_TYPES.GET_USER_INFO):
    case FAILURE(ACTION_TYPES.GET_USER_LIST):
    case FAILURE(ACTION_TYPES.GET_ACCOUNT_LIST):
    case FAILURE(ACTION_TYPES.GET_USER_COMPARISON):
    case FAILURE(ACTION_TYPES.CHANGE_ACCOUNT_STATUS):
    case FAILURE(ACTION_TYPES.GET_ACCOUNT_INFO):
    case FAILURE(ACTION_TYPES.CANCEL_USER):
    case FAILURE(ACTION_TYPES.DELETE_ACCOUNT):
    case FAILURE(ACTION_TYPES.LINK_ACCOUNT):
      return {
        ...initialState,
        loading: false,
        errorMessage: action.payload.response.data.errorKey
      };
    case FAILURE(ACTION_TYPES.EXPORT_EXCEL):
      return {
        ...state,
        errorMessage: action.payload.response.data.errorKey
      };
    case SUCCESS(ACTION_TYPES.GET_USER_LIST):
      return {
        ...initialState,
        loading: false,
        userList: action.payload.data,
        totalCount: action.payload.headers['x-total-count'] ? parseInt(action.payload.headers['x-total-count'], 10) : 0
      };
    case SUCCESS(ACTION_TYPES.GET_ACCOUNT_LIST):
      return {
        ...initialState,
        loading: false,
        accountList: action.payload.data,
        totalCount: action.payload.headers['x-total-count'] ? parseInt(action.payload.headers['x-total-count'], 10) : 0
      };
    case SUCCESS(ACTION_TYPES.GET_USER_INFO):
      return {
        ...initialState,
        loading: false,
        userInfo: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_USER_COMPARISON):
      return {
        ...state,
        loading: false,
        userComparison: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.EXPORT_EXCEL):
      return {
        ...state,
        resExportExcel: action.payload
      };
    case SUCCESS(ACTION_TYPES.APPROVE_USER):
      return {
        ...initialState,
        loading: false,
        responseApprove: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CHANGE_ACCOUNT_STATUS):
      return {
        ...initialState,
        loading: false,
        responseChange: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_ACCOUNT_INFO):
      return {
        ...initialState,
        loading: false,
        accountData: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CANCEL_USER):
      return {
        ...initialState,
        loading: false,
        resCancelUser: {
          ...action.payload.data,
          timestamp: new Date().getTime()
        }
      };
    case SUCCESS(ACTION_TYPES.DELETE_USER_APPROVE):
      return {
        ...initialState,
        loading: false,
        resDeleteUserApprove: {
          ...action.payload.data,
          timestamp: new Date().getTime()
        }
      };
    case SUCCESS(ACTION_TYPES.DELETE_ACCOUNT):
      if (action.payload.data && action.payload.data.status === 'ERROR') {
        return {
          ...state,
          loading: false,
          responseDelete: action.payload.data
        };
      } else {
        return {
          ...state,
          loading: false,
          responseDelete: { status: 'SUCCESS' }
        };
      }
    case SUCCESS(ACTION_TYPES.LINK_ACCOUNT):
      if (action.payload.data && action.payload.data.status === 'ERROR') {
        return {
          ...state,
          loading: false,
          resLinkAccount: action.payload.data
        };
      } else {
        return {
          ...state,
          loading: false,
          resLinkAccount: { status: 'SUCCESS' }
        };
      }
    case ACTION_TYPES.SAVE_USER_INFO:
      return {
        ...initialState,
        userData: action.payload
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export const handleGetUserList = (
  userType: string,
  type: string,
  page: number,
  limit: number,
  name: string | undefined,
  status: string | undefined
  // fromDate: Date | undefined,
  // toDate: Date | undefined
) => {
  // const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined;
  // const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : undefined;

  if (userType === 'IND') {
    userType = 'OFFICIAL';
  } else {
    userType = 'ORGANIZATION';
  }

  if (type === 'IMPLEMENT') {
    type = 'EDIT';
  } else if (type === 'CANCEL_ACCOUNT') {
    type = 'CANCELLATION';
  }

  let requestUrl = `api/approval-entries?userType.equals=${userType}&page=${page - 1}&size=${limit}`;
  if (type !== 'ACCOUNT') {
    requestUrl += `&type.equals=${type}`;
  }
  if (name) {
    requestUrl += `&fullName.contains=${name}`;
  }
  if (status) {
    requestUrl += `&status.equals=${status}`;
  }
  // if (formattedFromDate) {
  // }
  // if (formattedToDate) {
  // }

  return {
    type: ACTION_TYPES.GET_USER_LIST,
    payload: axios.get(requestUrl).catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
  };
};

export const handleGetAccountList = (
  userType: string,
  page: number,
  limit: number,
  name: string | undefined,
  status: string | undefined
  // fromDate: Date | undefined,
  // toDate: Date | undefined
) => {
  // const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined;
  // const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : undefined;
  let type: number;
  if (userType === 'IND') {
    type = 1;
  } else {
    type = 3;
  }

  let requestUrl = `/api/users/criteria?type.equals=${type}&page=${page - 1}&size=${limit}`;
  if (name) {
    requestUrl += `&fullName.contains=${name}`;
  }
  if (status === 'ACTIVATED') {
    requestUrl += `&requireChange.equals=${0}`;
  } else if (status === 'INACTIVE') {
    requestUrl += `&requireChange.equals=${1}`;
  } else if (status) {
    requestUrl += `&bindStatus.equals=${status}`;
  }

  // if (formattedFromDate) {
  // }
  // if (formattedToDate) {
  // }

  return {
    type: ACTION_TYPES.GET_ACCOUNT_LIST,
    payload: axios.get(requestUrl).catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
  };
};

export const handleGetUserInfo = id => ({
  type: ACTION_TYPES.GET_USER_INFO,
  payload: axios.get(`api/approval-entries/${id}`).catch(error => {
    console.error('Lỗi khi gọi API:', error);
  })
});

export const handleGetAccountInfo = login => ({
  type: ACTION_TYPES.GET_ACCOUNT_INFO,
  payload: axios
    .post('/api/user/manager', login, {
      headers: {
        'Content-Type': 'text/plain'
      }
    })
    .catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
});

export const handleGetUserComparison = (userId: string, userType: string) => {
  let requestUrl = `api/qlcb/api/users/getlistuser?`;

  if (userType === 'IND') {
    requestUrl += `cccd=${userId}`;
  } else {
    requestUrl += `email=${userId}`;
  }

  return {
    type: ACTION_TYPES.GET_USER_COMPARISON,
    payload: axios.get(requestUrl).catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
  };
};

export const handleApprove = (id, status, monreId?, ou?) => {
  let url = `api/approval-entries/status?id=${id}&status=${status}`;
  if (monreId) {
    url += `&monreId=${monreId}`;
  }
  if (ou) {
    url += `&ou=${ou}`;
  }
  return {
    type: ACTION_TYPES.APPROVE_USER,
    payload: axios.post(url).catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
  };
};

export const handleChangeAccountStatus = (login, activated) => ({
  type: ACTION_TYPES.CHANGE_ACCOUNT_STATUS,
  payload: axios.post(`/api/user/manager/update`, { login, activated }).catch(error => {
    console.error('Lỗi khi gọi API:', error);
  })
});

export const handleDelete = login => ({
  type: ACTION_TYPES.DELETE_ACCOUNT,
  payload: axios.delete('/api/user/manager', {
    data: login,
    headers: { 'Content-Type': 'application/json' }
  })
});

export const saveUserInfo = item => ({
  type: ACTION_TYPES.SAVE_USER_INFO,
  payload: item
});

export const cancelUser = reason => ({
  type: ACTION_TYPES.CANCEL_USER,
  payload: axios.post('api/approval-entries/cancel', { reason })
});

export const handleDeleteUserByIdApprove = id => ({
  type: ACTION_TYPES.DELETE_USER_APPROVE,
  payload: axios.delete(`api/approval-entries/${id}`).catch(error => {
    console.error('Lỗi khi gọi API:', error);
  })
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const handleLinkAccount = (userData, login) => {
  const formattedUserData = {
    username: userData.userName || null,
    bindMONRE: login || null,
    mail: userData.email || null,
    mobile: userData.mobile || null,
    cn: userData.fullName || null,
    unitCode: userData.unitCode || null,
    dateOfBirth: userData.dateOfBirth || null
  };

  return {
    type: ACTION_TYPES.LINK_ACCOUNT,
    payload: axios.post(`api/bind`, formattedUserData)
  };
};

export const handleExportExcel = (
  userType: string,
  type: string,
  page: number,
  limit: number,
  name: string | undefined,
  status: string | undefined
  // fromDate: Date | undefined,
  // toDate: Date | undefined
) => {
  // const formattedFromDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined;
  // const formattedToDate = toDate ? moment(toDate).format('YYYY-MM-DD') : undefined;

  if (userType === 'ORG') {
    userType = 'ORGANIZATION';
  } else {
    userType = 'OFFICIAL';
  }
  let requestUrl = `/api/approval-entries/export?userType.equals=${userType}&type.equals=${type}&page=${page - 1}&size=${limit}`;
  if (status) {
    requestUrl += `&status.equals=${status}`;
  }
  if (name) {
    requestUrl += `&fullName.contains=${name}`;
  }
  // if (formattedFromDate) {
  // }
  // if (formattedToDate) {
  // }

  return {
    type: ACTION_TYPES.EXPORT_EXCEL,
    payload: axios
      .get(requestUrl, { responseType: 'blob' })
      .then(response => {
        const contentDisposition = response.headers['content-disposition'];
        const filename = getFileNameFromContentDisposition(contentDisposition);

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);

        return {
          base64Data: url,
          contentType: response.headers['content-type'],
          filename: filename
        };
      })
      .catch(error => {
        console.error('Lỗi khi gọi API:', error);
        return {
          error: error.message
        };
      })
  };
};

function getFileNameFromContentDisposition(contentDisposition) {
  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
  return matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : 'downloaded_file.xlsx';
}
